import ProjectIndexListGroup from './ProjectIndexListGroup';
export default ProjectIndexListGroup;